var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}import React, { useCallback, useMemo } from 'react';
import FormGroup from "../../DocumentForm/components/FormGroup";

import { NeedAuthorization } from "../../Auth";
import { Translate } from "../../I18N";
import { MultiSelect } from "../../Forms";
import { Control } from 'react-redux-form';
import { Switcher } from "../../ReactReduxForms";












const generateOptions = (aggregations, level) => {var _aggregations$all, _aggregations$all2;return (
    (aggregations === null || aggregations === void 0 ? void 0 : (_aggregations$all = aggregations.all) === null || _aggregations$all === void 0 ? void 0 : (_aggregations$all2 = _aggregations$all[`_permissions.${level}`]) === null || _aggregations$all2 === void 0 ? void 0 : _aggregations$all2.buckets.
    filter((aggregation) => aggregation.key !== 'any').
    map((aggregation) => _objectSpread({
      label: aggregation.label,
      title: aggregation.label,
      value: aggregation.key,
      results: aggregation.filtered.doc_count },
    aggregation.icon ? { icon: { type: 'Icons', _id: aggregation.icon } } : {})
    )) || []);};

export const AssigneeFilterSelectUncontrolled = ({
  onChange,
  aggregations,
  value = []
}) => {
  const readOptions = useMemo(() => generateOptions(aggregations, 'read'), [aggregations]);
  const writeOptions = useMemo(() => generateOptions(aggregations, 'write'), [aggregations]);

  const getChangeHandler = (level) => (values) => {
    const newSelected = value.
    filter((v) => v.level !== level).
    concat(values.map((v) => ({ refId: v, level })));

    onChange(newSelected);
  };

  const onReadChangeHandler = useCallback(getChangeHandler('read'), [value, onChange]);
  const onWriteChangeHandler = useCallback(getChangeHandler('write'), [value, onChange]);

  const readValues = value.filter((v) => v.level === 'read').map((v) => v.refId);
  const writeValues = value.filter((v) => v.level === 'write').map((v) => v.refId);

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("li", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Shared as viewer")
    ), /*#__PURE__*/
    _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      prefix: "permissions.read",
      onChange: onReadChangeHandler,
      options: readOptions,
      value: readValues }
    )
    ), /*#__PURE__*/
    _jsx("li", { className: "spaced" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Shared as editor")
    ), /*#__PURE__*/
    _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
    _jsx(MultiSelect, {
      prefix: "permissions.write",
      onChange: onWriteChangeHandler,
      options: writeOptions,
      value: writeValues }
    )
    )
    ));

};

// eslint-disable-next-line react/no-multi-comp
const AssigneeFilterSelect = ({
  model,
  prefix,
  onChange,
  aggregations
}) => /*#__PURE__*/
// eslint-disable-next-line react/jsx-pascal-case
_jsx(Control.select, {
  component: AssigneeFilterSelectUncontrolled,
  model: model,
  prefix: prefix,
  onChange: onChange
  // @ts-ignore
  , aggregations: aggregations }
);


// eslint-disable-next-line react/no-multi-comp
export const AssigneeFilter = ({ onChange, aggregations }) => /*#__PURE__*/
_jsx(NeedAuthorization, {}, void 0, /*#__PURE__*/
_jsx(FormGroup, { className: "admin-filter" }, "permissions", /*#__PURE__*/
_jsx("ul", { className: "search__filter is-active" }, void 0, /*#__PURE__*/
_jsx("li", {}, void 0, /*#__PURE__*/
_jsx(Translate, {}, void 0, "Permissions"), /*#__PURE__*/
_jsx(Switcher, {
  model: ".customFilters['permissions'].and",
  prefix: "permissions",
  onChange: onChange }
)
), /*#__PURE__*/
_jsx(AssigneeFilterSelect, {
  model: ".customFilters['permissions'].values",
  prefix: "permissions",
  onChange: onChange,
  aggregations: aggregations }
)
)
)
);